<template>
    <div>
        Placeholder for Import Home
    </div>
</template>

<script>
export default {
  name: 'import-home'
}
</script>
